import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  addItem,
  updateItem,
} from '../../redux/cart/actions';
import PackagingProductItem from './PackagingProductItem';
import GiftWrapMessage from './GiftWrapMessage';
import GiftWrapAttributes from './GiftWrapAttributes';

class CartGiftWrap extends Component {
  constructor(props) {
    super(props);
    const {
      items: cartItems,
      giftWrapEnabled,
      updateItem,
      message: initialMessage,
    } = props;
    const {
      isEnabled,
      packagingProductIds,
      packagingProductsInCart,
      isGiftInCart,
    } = this.computed();
    
    // Use the admin-defined packaging product as initial value
    const activePackagingProductId = packagingProductsInCart?.[0]?.productId || packagingProductIds[0] || ''
    
    // If cart notes exist, show message textarea by default
    const isMsgVisible = Boolean(initialMessage)
    
    // Initialize state
    this.state = {
      activePackagingProductId,
      isMsgVisible,
      message: initialMessage
    };

    // console.log('props --- ', props)
    // console.log('state --- ', this.state)
    // console.log('computed --- ', this.computed())
  }

  // Callbacks ------------
  onPackagingChange({ target }) {
    const { state } = this;
    const oldVal = state.activePackagingProductId;
    const newVal = String(target.value);

    if (oldVal !== newVal) {
      this.updatePackagingInCart(oldVal, newVal)
      this.setState({ activePackagingProductId: newVal });
    }
  }
  onMessageCheckChange(evt) {
    if (!(evt?.target)) { return }
    const newVal = Boolean(evt.target.checked)
    
    // Reset message value
    if (!newVal) {
      this.setState({ message: '' });
    }
    
    this.setState({ isMsgVisible: newVal });
  }
  onMessageValChange(evt) {
    this.setState({ message: evt.target.value });
  }

  // Computed ------------
  isEnabled() {
    const {
      giftWrapEnabled,
      packagingProduct1,
      packagingProduct2,
    } = this.props;

    return giftWrapEnabled && (packagingProduct1 || packagingProduct2);
  }

  packagingProducts() {
    const {
      packagingProduct1,
      packagingProduct2,
      packagingTooltip1,
      packagingTooltip2,
    } = this.props;

    const value = [];
    if (packagingProduct1) {
      packagingProduct1.tooltip = packagingTooltip1 || ''
      value.push(packagingProduct1)
    }
    if (packagingProduct2) {
      packagingProduct2.tooltip = packagingTooltip2 || ''
      value.push(packagingProduct2)
    }
  
    return value;
  }
  
  allPackagingVariants() {
    const {
      packagingVariants1,
      packagingVariants2,
    } = this.props;

    return [...packagingVariants1, ...packagingVariants2];
  }
  
  activePackagingVariant() {
    const activePackagingProductId = String(this.state?.activePackagingProductId || '')
    return this
      .allPackagingVariants()
      .find((variant) => String(variant.productId) === activePackagingProductId);
  }

  packagingProductIds() {
    return this.packagingProducts().map((item) => String(item.id));
  }

  activePackagingProduct() {
    const activePackagingProductId  = this.state?.activePackagingProductId || ''
    return this.packagingProducts().find((item) => String(item.id) ===  String(activePackagingProductId));
  }

  packagingProductsInCart() {
    const { items: cartItems } = this.props;
    const packagingProductIds = this.packagingProductIds();
    const value = cartItems.filter(
      (cartItem) => packagingProductIds.includes(String(cartItem.productId)),
    );

    return value;
  }

  isGiftInCart() {
    return this.isEnabled()
      ? this.packagingProductsInCart().length > 0
      : false;
  }
  
  itemCount() {
    const totalItems =  this.props.items?.reduce(
      (total, item) => total + Number(item.quantity), 0
    ) || 0
    const totalPackagingProducts = this.packagingProductsInCart()?.length || 0

    return totalItems - totalPackagingProducts
  }

  computed() {
    return {
      isEnabled: this.isEnabled(),
      isGiftInCart: this.isGiftInCart(),
      packagingProducts: this.packagingProducts(),
      packagingProductIds: this.packagingProductIds(),
      packagingProductsInCart: this.packagingProductsInCart(),
      activePackagingProduct: this.activePackagingProduct(),
      activePackagingVariant: this.activePackagingVariant(),
      allPackagingVariants: this.allPackagingVariants(),
      itemCount: this.itemCount(),
    };
  }

  // Methods ------------ 
  toggleGiftWrapping() {
    const { updateItem, addItem } = this.props
    const { activePackagingVariant } = this.computed()
    const { isGiftInCart, packagingProductsInCart } = this.computed()

    if (isGiftInCart) {
      const keyToRemove = packagingProductsInCart[0].key
      updateItem(keyToRemove, 0);
    } else if (!isGiftInCart && activePackagingVariant) {
      addItem(activePackagingVariant.variantId, 1, activePackagingVariant);
    }
  }
  updatePackagingInCart(oldVal, newVal) {
    const { updateItem, addItem, items:cartItems } = this.props
    const { allPackagingVariants } = this.computed()
    const keyToRemove = cartItems.find((item) => String(item.productId) === String(oldVal))?.key
    const variantToAdd = allPackagingVariants.find((variant) => String(variant.productId) === String(newVal));
    
    // return updateItem(keyToRemove, 0)
    //   .then(() => addItem(variantToAdd.variantId, 1, variantToAdd))
    //   .catch(err => false)
    return addItem(variantToAdd.variantId, 1, variantToAdd)
      .catch(err => false)
  }

  // Hooks ------------
  render() {
    const { isLoading, updateItem, items: cartItems } = this.props;
    const {
      activePackagingProductId,
      isMsgVisible,
      message } = this.state;
    const {
      isEnabled,
      isGiftInCart,
      packagingProducts,
      packagingProductsInCart,
      itemCount,
    } = this.computed();
    

    const fieldsetId = 'cart-gift-wrap__fieldset';
    const attributesContent = itemCount >= 2 && ( <GiftWrapAttributes/> )
    

    return isEnabled && (
      <div className="cart-gift-wrap">
        <label className="form-control custom-checkbox-wrapper" htmlFor="cart-gift-wrap__toggle">
          <span>Is this a gift?</span>
          <input
            id="cart-gift-wrap__toggle"
            type="checkbox"
            onChange={() => { this.toggleGiftWrapping(); }}
            checked={isGiftInCart}
            disabled={isLoading}
          />
		  <span className="custom-checkbox__icon"></span>
        </label>

        { isGiftInCart && (
          <div className="cart-gift-wrap__content">
            <div className="row">
              <div className="col-12 col-lg-8">
                <fieldset id={fieldsetId} onChange={(evt) => { this.onPackagingChange(evt); }}>
                  <div className="row">
                    { packagingProducts.map((item) => (
                      <div className="col-12 col-md-6" key={item.id}>
                        <PackagingProductItem
                          product={item}
                          groupId={fieldsetId}
                          isActive={String(item.id) === activePackagingProductId}
                        />
                      </div>
                    )) }
                  </div>
                </fieldset>
              </div>
              <div className="col-12 col-lg-4">
                <div className="cart-gift-wrap__options-wrapper">
                  <GiftWrapMessage
                    isVisible={isMsgVisible}
                    message={message}
                    onChangeCallback={ (evt) => { this.onMessageCheckChange(evt) } }
                    onMessageChange={ (evt) => { this.onMessageValChange(evt) } } />

                  { attributesContent }
                </div>
              </div>
            </div>
          </div>
        ) }
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
  items: state.cart.items,
});

const mapDispatchToProps = {
  updateItem,
  addItem,
};

CartGiftWrap.propTypes = {
  isLoading: PropTypes.bool.isRequired,

  items: PropTypes.arrayOf(PropTypes.object).isRequired,

  giftWrapEnabled: PropTypes.bool,
  packagingProduct1: PropTypes.objectOf(PropTypes.any),
  packagingProduct2: PropTypes.objectOf(PropTypes.any),
  packagingVariants1: PropTypes.arrayOf(PropTypes.any),
  packagingVariants2: PropTypes.arrayOf(PropTypes.any),
  message: PropTypes.string,
  updateItem: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
};

CartGiftWrap.defaultProps = {
  giftWrapEnabled: false,
  packagingProduct1: null,
  packagingProduct2: null,
  packagingVariants1: [],
  packagingVariants2: [],
  message: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(CartGiftWrap);
